import { __decorate, __metadata, __param } from "tslib";
import { Symbols } from '@/symbols';
import { inject, injectable } from 'inversify';
let WhitelistService = class WhitelistService {
    constructor(api) {
        this.api = api;
        this.categorySearchFn = () => null;
    }
    async getWhitelist() {
        const res = await this.api.getWhitelistApi();
        return res.data;
    }
    removeWhitelistItem(whitelistId) {
        return this.api.removeWhitelistApi(whitelistId);
    }
    saveWhitelistItem(data) {
        return this.api.saveWhitelistApi(data);
    }
    async getWhitelistApis() {
        const res = await this.api.getWhitelistApisApi();
        return res.data;
    }
};
WhitelistService = __decorate([
    injectable(),
    __param(0, inject(Symbols.OpenApi)),
    __metadata("design:paramtypes", [Object])
], WhitelistService);
export { WhitelistService };
